const MessageView = function({ dom }) {

  const messageEl = d3.select(dom);
  var timeoutId = null;

  const reset = () => {
    clearTimeout(timeoutId);
    messageEl.class("message")
      .style("display", "none").html("");
  } 

  const info = (text, timeout = 0) => {
    clearTimeout(timeoutId);
    messageEl.class("message")
      .style("display", text ? "block" : "none").html(text);
    if (timeout) timeoutId = setTimeout(reset, timeout);
  }

  const bad = (text, timeout = 0) => {
    clearTimeout(timeoutId);
    messageEl.class("message is-error")
      .style("display", text ? "block" : "none").html(text);
    if (timeout) timeoutId = setTimeout(reset, timeout);
  }

  const good = (text, timeout = 0) => {
    clearTimeout(timeoutId);
    messageEl.class("message is-ok")
      .style("display", text ? "block" : "none").html(text);
    if (timeout) timeoutId = setTimeout(reset, timeout);
  }

  const progress = (text, timeout = 0) => {
    clearTimeout(timeoutId);
    const match = text && text.match(/(\d+)\/(\d+)/);
    const pct = match ? Math.round(100 * match[1] / match[2]) : null;
    const bar = pct !== null ? `<div class="message-progress-bar" style="width:${pct}%"></div>` : "";
    messageEl.class("message is-working")
      .style("display", text ? "block" : "none")
      .html(text ? `${bar}<span class="message-text">${text}</span>` : "");
    if (timeout) timeoutId = setTimeout(reset, timeout);
  }

  return { info, bad, good, progress };
}

export default MessageView;